// Chat.js
import React, { useState } from 'react';
import './Chat.css';
import ChatRoom from './components/ChatRoom';

function Chat(props) {
  const { samplesList, moduleList, moduleKey, isDetailsPage, onChatError, onResetSamples, onResetItems, currentUser, activeTab, paddingBottom } = props;
  const [selectedSample, setSelectedSample] = useState(null);
  const effectiveList = Array.isArray(moduleList) && moduleList.length ? moduleList : samplesList;
  const handleReset = onResetItems || onResetSamples;

  return (
    <div className="chat-wrapper">
      <ChatRoom
        samplesList={effectiveList}
        isDetailsPage={isDetailsPage}
        selectedSample={selectedSample}
        setSelectedSample={setSelectedSample}
        currentUser={currentUser}
        onChatError={onChatError}
        onResetSamples={handleReset}
        moduleKey={moduleKey}
        activeTab={activeTab}
        paddingBottom={paddingBottom}
      />
    </div>
  );
}

export default Chat;
